import { ChangeEvent, useEffect } from "react";
import { Form } from "../../../system/useForm";
import { addressSetter } from "./ReturnOrderUtils";
import { VehicleAddresses } from "../../../system/Domain";
import { FormControl, FormControlLabel, Radio, RadioGroup, useTheme } from "@mui/material";

interface Props {
	name: string;
	form: Form;
	required?: boolean;
	isRkv: boolean;
	aldAddressData: VehicleAddresses;
	disabled?: boolean;
}

const AssessmentRadioChoice = (props: Props) => {
	const theme = useTheme();
	useEffect(() => {
		props.form.register(props.name, { required: props.required ?? false });

		return () => {
			props.form.unregister(props.name);
		};
	}, [props.name]);

	const handleAssessmentLocationChange = (event: ChangeEvent<HTMLInputElement>) => {
		const selectedValue = (event.target as HTMLInputElement).value;

		props.form.setValue(props.name, selectedValue);
		props.form.validate(props.name, selectedValue);

		if (selectedValue === "RkvAddress") {
			addressSetter("assessment.address", props.form, props.aldAddressData.rkvAddress);
		}
	};

	const radio = <Radio sx={!!props.form.errors[props.name] && { color: theme.palette.error.main }} color="primary" />;

	return (
		<FormControl
			component="fieldset"
			sx={!!props.form.errors[props.name] && { color: theme.palette.error.main }}
			disabled={props.disabled}
		>
			<RadioGroup
				row
				name={props.name}
				value={props.form.getValue(props.name) ?? ""}
				onChange={handleAssessmentLocationChange}
			>
				<FormControlLabel value="CollectionAddress" control={radio} label="Abholadresse" labelPlacement="end" />
				<FormControlLabel value="DeliveryAddress" control={radio} label="Lieferadresse" labelPlacement="end" />
				{props.isRkv && (
					<FormControlLabel
						value="RkvAddress"
						control={radio}
						label="RKV-Geberadresse"
						labelPlacement="end"
					/>
				)}
			</RadioGroup>
		</FormControl>
	);
};

export default AssessmentRadioChoice;
